import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <ul>
      <li parentName="ul">{`Third year CSE, COEP.`}</li>
      <li parentName="ul">{`Intermediate Python3 Developer.`}</li>
      <li parentName="ul">{`Data structures and Algorithms.`}</li>
      <li parentName="ul">{`Aspire to be a full-stack web developer.`}</li>
      <li parentName="ul">{`Above average Linux User.`}</li>
      <li parentName="ul">{`Strong problem-solving and analytical skills`}</li>
      <li parentName="ul">{`Enjoy working as a team member as well as independently.`}</li>
    </ul>
    <h3>{`POWER SKILLS :`}</h3>
    <ul>
      <li parentName="ul">{`Front End : HTML,CSS, Javascript, Bootstrap. `}</li>
      <li parentName="ul">{`Back End : Python, PHP, Javascript.`}</li>
      <li parentName="ul">{`Frameworks : Flask, Node.js, Gatsby.`}</li>
      <li parentName="ul">{`Databases : MySQL ( Relational Database)`}</li>
      <li parentName="ul">{`Dev : Linux, Git, Bash, Netlify, Github pages.`}</li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      